const initialState = {
  profileImage: null,
  notificationCount:null,
  notificationList: [],
};

const profileReducer = (state = initialState, action) => {
    if (action.type==="UPDATE_PROFILE_IMAGE") {
        return {
          ...state,
          profileImage: action.payload,
        }
      }else  if (action.type==="UPDATE_PROFILE_NAME") {
        return {
          ...state,
          profileName: action.payload,
        }
      }
      
      else if(action.type==="NOTIFICATION_COUNT"){
        return {
          ...state,
          notificationCount: action.payload,
        }
      }else if(action.type==="NOTIFICATION_LIST"){
        return {
          ...state,
          notificationList: action.payload,
        }
      }
      else{return state;}
  };
  
  export default profileReducer;
  